<template>
    <el-dialog title="Livreur" :visible.sync="thisvisible">
        <div class="form-container">
            <div v-loading="loading" class="form-container">
                <el-form
                    ref="livreurForm"
                    :model="thislivreur"
                    :rules="rules"
                    label-position="left"
                    label-width="150px"
                    style="max-width: 500px;"
                >
                    <template v-if="thislivreur.cps_montagne">
                        <el-form-item label="Prix" prop="data">
                            <el-input v-model="cps" />
                        </el-form-item>
                    </template>
                    <template v-else-if="thislivreur.excel">
                        <el-upload
                            drag
                            :action="
                                '/api/livreurs/' + thislivreur.id + '/files'
                            "
                            :on-success="handleSucess"
                            :headers="headers"
                            :on-error="handleError"
                            :file-list="fileList"
                            :on-progress="handleProgress"
                            name="excel"
                        >
                            <i class="el-icon-upload" />
                            <div class="el-upload__tip">
                                Tarif excel
                            </div>
                        </el-upload>
                    </template>

                    <template
                        v-else-if="thislivreur.maxcol && thislivreur.data"
                    >
                        <el-form-item label="Prix" prop="data">
                            <el-input v-model="thislivreur.data" />
                        </el-form-item>
                    </template>
                    <template v-else>
                        <el-form-item
                            label="Nom"
                            prop="nom"
                            :error="getErrorForField('nom', errors)"
                        >
                            <el-input v-model="thislivreur.nom" />
                        </el-form-item>
                        <el-form-item
                            label="Assurance"
                            prop="assurance"
                            :error="getErrorForField('assurance', errors)"
                        >
                            <el-input v-model="thislivreur.assurance" />
                        </el-form-item>
                        <el-form-item
                            label="Tax mont."
                            prop="taxmontagne"
                            :error="getErrorForField('taxmontagne', errors)"
                        >
                            <el-input v-model="thislivreur.taxmontagne" />
                        </el-form-item>
                        <el-form-item
                            label="Tax gasoil"
                            prop="taxgasoil"
                            :error="getErrorForField('taxgasoil', errors)"
                        >
                            <el-input v-model="thislivreur.taxgasoil" />
                        </el-form-item>

                        <el-form-item label="État" prop="etat">
                            <el-select
                                v-model="thislivreur.etat"
                                placeholder="Select"
                            >
                                <el-option
                                    v-for="etat in etats"
                                    :key="etat.value"
                                    :label="etat.label"
                                    :value="etat.value"
                                />
                            </el-select>
                        </el-form-item>
                    </template>
                    <el-form-item>
                        <el-button type="info" @click="thisvisible = false">
                            Annuler
                        </el-button>
                        <el-button
                            v-if="!thislivreur.excel"
                            type="primary"
                            @click="save"
                        >
                            Enregistrer
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import Resource from "@/api/resource";
import { getToken } from "@/utils/auth";
const livreurResource = new Resource("livreurs");

export default {
    name: "Livreur",
    props: {
        isvisible: {
            type: Boolean,
            default: false
        },
        livreur: {
            type: Object,
            default: () => {
                return {
                    nom: "Nouveau",
                    etat: "inactif",
                    assurance: 0.006,
                    taxmontagne: 18.3,
                    taxgasoil: 0.039,
                    maxcol: null,
                    departement_id: null,
                    data: null,
                    cps_montagne: null
                };
            }
        },
        parent: {
            type: Object
        }
    },
    data() {
        return {
            thisvisible: false,
            loading: false,
            rules: {
                // annee: {type: "year"}
            },
            fileList: [],
            headers: {
                Authorization: "Bearer " + getToken()
            },
            errors: [],
            thislivreur: {
                nom: "Nouveau",
                etat: "inactif",
                assurance: 0.006,
                taxmontagne: 18.3,
                taxgasoil: 0.039,
                maxcol: null,
                departement_id: null,
                data: null,
                cps_montagne: null
            },
            etats: [
                { value: "actif", label: "Actif" },
                { value: "inactif", label: "Inactif" }
            ]
        };
    },
    watch: {
        isvisible(val) {
            if (val) {
                this.thisvisible = val;
                this.errors = [];
                if (this.livreur) {
                    Object.assign(this.thislivreur, this.livreur);
                }
            }
        },
        thisvisible(val) {
            if (!val) {
                this.parent.dialogLivreurVisible = val;
                this.errors = [];
            }
        }
    },
    computed: {
        cps: {
            set: function(val) {
                this.thislivreur.cps_montagne = val.replace(" ", "").split(",");
            },
            get: function() {
                return this.thislivreur.cps_montagne.join();
            }
        }
    },

    methods: {
        handleProgress() {
            this.loading = true;
        },
        handleSucess(response) {
            if (response.data) {
                this.$message({
                    type: "success",
                    message: "excel importé",
                    duration: 1 * 5000
                });
                this.parent.callbackLivreur(true, response.data);
                this.thisvisible = false;
                this.loading = false;
            } else if (response.error) {
                this.$message({
                    type: "error",
                    message: response.error,
                    duration: 1 * 5000
                });
                this.thisvisible = false;
                this.loading = false;
            }
        },
        handleError(err) {
            this.$message({
                type: "error",
                message: err,
                duration: 1 * 5000
            });
            this.thisvisible = false;
        },
        save() {
            this.errors = [];
            this.loading = true;
            if (this.thislivreur.id) {
                livreurResource
                    .update(this.thislivreur.id, this.thislivreur)
                    // .then(response => {
                    .then(response => {
                        this.loading = false;
                        var reload =
                            !!this.thislivreur.maxcol ||
                            !!this.thislivreur.cps_montagne;
                        this.parent.callbackLivreur(reload, response.data);
                        this.thisvisible = false;
                        this.$message({
                            message: "Livreur mis à jour",
                            type: "success",
                            duration: 5 * 1000
                        });
                    })
                    .catch(error => {
                        if (error.response && error.response.data) {
                            this.errors = error.response.data.errors;
                        }
                        console.log("error");
                        console.log(error.response);
                        this.loading = false;
                    });
            } else {
                livreurResource
                    .store(this.thislivreur)
                    .then(response => {
                        this.loading = false;
                        this.thisvisible = false;
                        this.$message({
                            message: "Livreur créée",
                            type: "success",
                            duration: 5 * 1000
                        });
                        console.log(response);
                        this.parent.callbackLivreur(true, false);
                    })
                    .catch(error => {
                        if (error.response && error.response.data) {
                            this.errors = error.response.data.errors;
                        }
                        console.log("error");
                        console.log(error.response);
                        this.loading = false;
                    });
            }
        },
        getErrorForField(field, errors) {
            if (errors && errors[field]) {
                return errors[field].join(" ");
            }
        }
    }
};
</script>
